export const HatConstants = {
    hatSelector: ".nw_2021_hat",
    harWrapperSelector: ".nw_2021_hat-wrapper",
    dataScrollDown: "data-scroll-down",
    dataScrollUp: "data-scroll-up",
    scrollDownClass: "scroll_down",
    top: "top",
    bottom: "bottom"
}
